module.exports = __webpack_public_path__ + "img/绑定.42a715d8.png";